export const createDistrict = /* GraphQL */ `
    mutation CreateDistrict(
        $input: CreateDistrictInput!
        $condition: ModelDistrictConditionInput
    ) {
        createDistrict(input: $input, condition: $condition) {
            id
            slug
            name {
                legal
                popular
            }
            avatar {
                size
                name
                src
            }
            zone {
                id
                name
            }
            schools {
                items {
                    id
                }
                nextToken
            }
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;

export const listZones = /* GraphQL */ `
    query ListZones(
        $id: ID
        $filter: ModelZoneFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
    ) {
        listZones(
            id: $id
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            sortDirection: $sortDirection
        ) {
            items {
                id
                name
                counties
                state {
                    enabled
                }
            }
            nextToken
        }
    }
`;

export const onUpdateZone = /* GraphQL */ `
    subscription OnUpdateZone {
        onUpdateZone {
            id
            name
            state {
                enabled
            }
        }
    }
`;

